import React from 'react'
import Star from '../../assets/Icons/Star'
import { StarList } from './styles'

const stars = [1, 2, 3, 4, 5]

const Stars = ({ value = 0, onChange, disabled }) => {
  return (
    <StarList disabled={disabled}>
      {stars.map((star) => (
        <li key={star} data-value={star} onClick={() => onChange(star)}>
          <Star on={star <= value} />
        </li>
      ))}
    </StarList>
  )
}

export default Stars
